export default "__VITE_ASSET__DkLpLCiy__"